module.exports = __webpack_public_path__ + "img/search-input.930fc821.svg";